import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Form, Modal, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import configuration from 'modules/configuration'
import { notifyMappingError } from '../../../utils'

const MapRowModal = ({
  visible,
  onClose,
  onRefetch,
  mapping,
  unmappedSources,
  onSearchSources,
  valuesByTarget,
  createDimensionMappingRow,
}) => {
  const [form] = Form.useForm()
  const [isSaving, setIsSaving] = useState(false)
  const { t } = useTranslation()

  const sourceLabel = mapping?.labels?.[mapping?.source_dimension] ?? ''

  const handleClose = () => {
    form.resetFields()
    setIsSaving(false)
    onClose()
  }

  const handleCreate = () => {
    form.validateFields().then(({ source_value_id, ...values }) => {
      setIsSaving(true)
      createDimensionMappingRow(mapping.source_dimension, { source_value_id, values })
        .then(() => {
          onRefetch()
          handleClose()
        })
        .catch((error) => {
          setIsSaving(false)
          notifyMappingError(error)
        })
    })
  }

  const toOptions = (values = []) =>
    values.map((value) => ({
      value: value.id,
      label: `${value.code_destination} - ${value.name_destination}`,
    }))

  return (
    <Modal
      title={t('CONFIG_DIMENSION_MAPPING_ROW_MODAL_TITLE', { source: sourceLabel })}
      visible={visible}
      onCancel={handleClose}
      onOk={handleCreate}
      okText={t('ACTION_SAVE')}
      cancelText={t('ACTION_CANCEL')}
      confirmLoading={isSaving}
      destroyOnClose
      centered
      forceRender
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="source_value_id"
          label={sourceLabel}
          rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
        >
          {/* Solo los no mapeados: el origen queda bloqueado al mapearse */}
          <Select
            options={toOptions(unmappedSources)}
            placeholder={t('ACTION_SELECT')}
            onSearch={onSearchSources}
            filterOption={false}
            showSearch
          />
        </Form.Item>
        {(mapping?.targets ?? []).map((target) => (
          <Form.Item
            key={target}
            name={target}
            label={mapping.labels?.[target] ?? target}
            rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
          >
            <Select
              options={toOptions(valuesByTarget[target])}
              placeholder={t('ACTION_SELECT')}
              showSearch
              optionFilterProp="label"
            />
          </Form.Item>
        ))}
      </Form>
    </Modal>
  )
}

const mapDispatchToProps = {
  createDimensionMappingRow: configuration.actions.createDimensionMappingRow,
}

export default connect(null, mapDispatchToProps)(MapRowModal)
